import { Routes } from "@angular/router";
import { mobileElearningQuizEntryGuard } from "./mobile-elearning-quiz-entry.guard";

/** Routes du parcours e-learning connecté (séquences → activités → lecteur), comme `authenticatedSignatureRoutes`. */
export const authenticatedElearningPlayerRoutes: Routes = [
  {
    path: "quiz",
    canActivate: [mobileElearningQuizEntryGuard],
    children: [],
  },
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./mobile-elearning-sequence-list-page/mobile-elearning-sequence-list-page.component").then(
        (moduleExports) => moduleExports.MobileElearningSequenceListPageComponent
      ),
  },
  {
    path: ":sequenceUid/activities",
    loadComponent: () =>
      import("./mobile-elearning-activity-list-page/mobile-elearning-activity-list-page.component").then(
        (moduleExports) => moduleExports.MobileElearningActivityListPageComponent
      ),
  },
  {
    path: ":sequenceUid/activities/:activityUid/player",
    loadComponent: () =>
      import("./mobile-elearning-activity-player-page/mobile-elearning-activity-player-page.component").then(
        (moduleExports) => moduleExports.MobileElearningActivityPlayerPageComponent
      ),
  },
];
